import map from 'mn-utils/map';
import isFunction from 'mn-utils/isFunction';
import {
  routerByLocationProvider,
} from '../../router';
import routes from './routes';

const ROUTERS = map(routes, ([url, data]) => [url, isFunction(data) ? data : (params, location) => {
  return {
    params,
    location,
    ...data,
  };
}], []);

export const router$ = routerByLocationProvider(ROUTERS, (params, location) => ({
   params,
   location,
   title: 'Page not found',
   main: require('../../components/pages/PublicError/NotFound'),
   public: 1,
}));
